import { ScreenerSettingName } from '@/hooks/screener-settings/screenerSettingName';

import { useHasFaxIntegration } from './useHasFaxIntegration';
import { useScreenerSettingFindOne } from './useScreenerSettingsQuery';

const SETTINGS_STALE_TIME_MS = 5 * 60 * 1000;

export type InboundDocumentsAvailability =
  | { status: 'loading' }
  | { status: 'error'; retry: () => void }
  | { status: 'enabled' }
  | { status: 'disabled' };

export function useIsInboundDocumentsEnabled(): InboundDocumentsAvailability {
  const { hasFaxIntegration, isLoading } = useHasFaxIntegration();
  const settingQuery = useScreenerSettingFindOne(
    { settingName: ScreenerSettingName.InboundDocuments },
    { staleTime: SETTINGS_STALE_TIME_MS }
  );
  if (isLoading) {
    return { status: 'loading' };
  }
  if (!hasFaxIntegration) {
    return { status: 'disabled' };
  }
  if (settingQuery.data === undefined) {
    return settingQuery.isError
      ? { status: 'error', retry: () => void settingQuery.refetch() }
      : { status: 'loading' };
  }
  return {
    status: settingQuery.data.data?.value === 'enabled' ? 'enabled' : 'disabled'
  };
}
